var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5001 28.583L23.4394 29.6437L24.5001 30.7043L25.5607 29.6437L24.5001 28.583ZM26.0001 10.208C26.0001 9.37958 25.3285 8.70801 24.5001 8.70801C23.6717 8.70801 23.0001 9.37958 23.0001 10.208L26.0001 10.208ZM13.2311 19.4353L23.4394 29.6437L25.5607 27.5223L15.3524 17.314L13.2311 19.4353ZM25.5607 29.6437L35.7691 19.4353L33.6478 17.314L23.4394 27.5223L25.5607 29.6437ZM26.0001 28.583L26.0001 10.208L23.0001 10.208L23.0001 28.583L26.0001 28.583Z",
    fill: "#122D58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2083 32.667L10.2083 34.7087C10.2083 36.9638 12.0364 38.792 14.2916 38.792L34.7083 38.792C36.9634 38.792 38.7916 36.9638 38.7916 34.7087V32.667",
    stroke: "#122D58",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.cbb1c709a9c849e042517f839198210e.svg";
export { ForwardRef as ReactComponent };